import { faMusic, faPlay, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const WhyChooseUs = () => {
    return (   
        <div className="max-w-6xl mx-auto py-8 px-6 text-center">
          <h2 className="text-3xl font-bold text-yellow-400">Why Choose Us?</h2>
          <p className="text-gray-300 mt-3">
            We help artists get their music heard worldwide.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div className="bg-gray-900 p-6 rounded-lg shadow-lg">
              <FontAwesomeIcon
                icon={faMusic}
                className="text-4xl text-yellow-400"
              />
              <h3 className="text-xl font-semibold mt-4">
                Multi-Platform Distribution
              </h3>
              <p className="text-gray-300 mt-2">
                Reach fans on Spotify, Apple Music, YouTube, and more.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg shadow-lg">
              <FontAwesomeIcon
                icon={faPlay}
                className="text-4xl text-yellow-400"
              />
              <h3 className="text-xl font-semibold mt-4">Maximize Streams</h3>
              <p className="text-gray-300 mt-2">
                Boost your streams with strategic promotion.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg shadow-lg">
              <FontAwesomeIcon
                icon={faGlobe}
                className="text-4xl text-yellow-400"
              />
              <h3 className="text-xl font-semibold mt-4">Global Reach</h3>
              <p className="text-gray-300 mt-2">
                Expand your audience and grow your fanbase.
              </p>
            </div>
          </div>
        </div> );
}
 
export default WhyChooseUs;